<form (ngSubmit)="submit()" [formGroup]="form" class="flex flex-col gap-7">
  <h3>Alta de empleado</h3>

  <input (change)="handleAvatarSelected($event)" accept="image/*" class="hidden" id="employee-avatar-input" type="file">
  <button (click)="openAvatarPicker()" [disabled]="isSubmitting" class="btn btn-neutral-outline avatar !w-[3rem] !h-[3rem] overflow-hidden" type="button">
    @if (avatarPreviewUrl) {
      <img [src]="avatarPreviewUrl" alt="Foto de perfil" class="h-full w-full object-cover">
    }
  </button>

  <core-employee-form-sections
    [contractFileName]="contractFileName"
    [existingAttachments]="[]"
    [form]="form"
    [groupOptions]="groupOptions"
    [isLoadingOptions]="isLoadingOptions"
    [isSubmitting]="isSubmitting"
    [pendingAttachments]="pendingAttachments"
    [roleDisabled]="false"
    [roleOptions]="roleOptions"
    (contractSelected)="handleContractSelected($event)"
    (documentsSelected)="handleDocumentsSelected($event)"
    (removePendingAttachment)="removePendingAttachment($event)"/>

  @if (errorMessage) {
    <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
  }

  <div class="w-full flex flex-row items-center gap-4">
    <button (click)="close()" [disabled]="isSubmitting" class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]" style="border-radius: 0.5rem;padding: 0.5rem 1rem"
            type="button">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/x.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">Cancelar</span>
    </button>

    <button [disabled]="isSubmitting || isLoadingOptions" class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]" style="border-radius: 0.5rem;padding: 0.5rem 1rem"
            type="submit">
      <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/plus-square.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">
        {{ isSubmitting ? 'Guardando...' : 'Agregar empleado' }}
      </span>
    </button>
  </div>
</form>
